export function buildBookingSuccessRedirectUrl(value) {
  const raw = String(value || '').trim();
  if (!raw || typeof window === 'undefined') return '';

  try {
    const parsed = new URL(raw, window.location.origin);
    if (!['http:', 'https:'].includes(parsed.protocol)) return '';
    parsed.searchParams.set('mib_conversion', 'booking');
    return parsed.toString();
  } catch {
    return '';
  }
}
